import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { firstValueFrom } from 'rxjs'
import { environment } from '@env'
import { Benefit, BenefitsItems, CreateBenefitPayload, GetBenefitsParams } from '@models'

@Injectable({ providedIn: 'root' })
export class BenefitService {
  private readonly baseUrl = `${environment.api.baseUrl}/benefit-services/v1/benefits`

  constructor(private http: HttpClient) {}

  async getAll(params: GetBenefitsParams): Promise<BenefitsItems> {
    let httpParams = new HttpParams().set('page', params.page.toString()).set('pageSize', params.pageSize.toString())

    if (params.orderBy) httpParams = httpParams.set('orderBy', params.orderBy)
    if (params.order) httpParams = httpParams.set('order', params.order)
    if (params.text) httpParams = httpParams.set('text', params.text)
    if (params.status !== undefined) httpParams = httpParams.set('status', params.status.toString())
    if (params.availability) httpParams = httpParams.set('availabillity', params.availability)
    if (params.benefitGroups) httpParams = httpParams.set('benefitGroups', params.benefitGroups)

    const response = await firstValueFrom(this.http.get<BenefitsItems>(this.baseUrl, { params: httpParams }))
    return response
  }

  async getById(id: string): Promise<Benefit> {
    const response = await firstValueFrom(this.http.get<Benefit>(`${this.baseUrl}/${id}`))
    return response
  }

  async create(payload: CreateBenefitPayload): Promise<Benefit> {
    const response = await firstValueFrom(this.http.post<Benefit>(this.baseUrl, payload))
    return response
  }

  async update(id: string, payload: CreateBenefitPayload): Promise<Benefit> {
    const response = await firstValueFrom(this.http.put<Benefit>(`${this.baseUrl}/${id}`, payload))
    return response
  }

  async delete(id: string): Promise<void> {
    const response = await firstValueFrom(this.http.delete<void>(`${this.baseUrl}/${id}`))
    return response
  }
}
